import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const StyledLink = styled(Link)`
  padding: 12px 16px;
  width: 100%;
  display: flex;
  position: relative;
  box-sizing: border-box;
  text-align: left;
  align-items: center;
  justify-content: flex-start;
  text-decoration: none;
  color: ${(props) => props.theme.atlas.semantic.color.type.inverse};
  width: 100%;
  height: 100%;
  font-size: 1rem;
  font-family: ${(props) =>
    props.theme.atlas.typography.semantic.bodySmall.fontFamily};
  font-weight: 400;
  line-height: 1.5;
  &:hover {
    color: ${(props) =>
      props.theme.atlas.semantic.color.action.primary.onPrimary};
    background-color: ${(props) =>
      props.theme.atlas.semantic.color.action.primary.default};
  }
`;
